import popupActions from '../../redux/actions/popupActions';
import popupContent from '../../content/popup';

import Update from './update';
import Clear from './clear';
import Redirect from './redirect';

const Popup = (props: { service: string }) => {

	const { isVisible, selectedPopup } = popupActions();
	const content = popupContent(props.service);

	return (
		<div
			className={`popup ${selectedPopup === 'redirect_popup' ? 'redirect_popup' : ''} ${
				selectedPopup === 'clean_popup' ? 'popup__remove' : ''
			}`}
			style={{ display: isVisible ? 'flex' : 'none' }}
		>
			<div className="popup__background"></div>
			<div className="popup__content">
				{getSelectedPopup(selectedPopup, content, props.service)}
			</div>
		</div>
	);
};

const getSelectedPopup = (
	selectedPopup: string,
	content: {
    clear: {
      title: string;
      description: string;
      question: string;
      actionButton: string;
    };
  },
	service: string
): JSX.Element => {
	if (selectedPopup === 'clean_popup') return <Clear content={content.clear} />;
	if (selectedPopup === 'redirect_popup') return <Redirect />; 
	return <Update service={service} />;
};

export default Popup;
